import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation('common');

  return (
    <Box component="footer" sx={{ py: 3, px: 2, mt: 'auto' }}>
      <Container maxWidth={false}>
        <Typography
          variant="caption"
          sx={{ display: 'flex', justifyContent: 'center' }}
          align="center"
          color="text.secondary"
        >
          {t('footer.copyright', { year: currentYear })}
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
